import { envConfig, envToBusinessUnit, getGenericUser } from '@grupoboticario/barril-del-chavo'
import { BrandName, BrandNameText } from 'src/@enums'

export const getConfig = (uf?: string) => {
  const brandEnv = envConfig.currentBrand as BrandName | undefined
  if (!brandEnv) {
    throw new Error(`Invalid env value for REACT_APP_CURRENT_BRAND: ${brandEnv}`)
  }

  const brand = BrandNameText[brandEnv]
  const businessUnit = envToBusinessUnit[brandEnv]
  const genericUser = getGenericUser({ uf, businessUnit: envToBusinessUnit[brandEnv] })
  const isBoticario = brandEnv === BrandName.BOTICARIO
  const isEuAmoMake = brandEnv === BrandName.EU_AMO_MAKE
  const isEudora = brandEnv === BrandName.EUDORA
  const isOuiParis = brandEnv === BrandName.OUI
  const thumbnailDefault = `https://meucatalogodigitalresources.grupoboticario.digital/assets/images/avatar/thumb-${brandEnv.toLowerCase()}.png`

  return {
    brand,
    brandEnv,
    businessUnit,
    genericUser,
    isBoticario,
    isEuAmoMake,
    isEudora,
    isOuiParis,
    thumbnailDefault,
  }
}
